/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import {
    Box,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Text,
    Button
} from 'grommet'

function FullPageRenderingErrorFallback({ error }) {
    return (
        <Card width='25rem' animation='fadeIn' margin='5rem auto'>
            <CardHeader justify='center' background='#ca0a0a'>
                <Text color="#fff" size='medium' margin='small'>Ошибка</Text>
            </CardHeader>
            <CardBody pad="medium">
                <Box gap="small" justify="center" direction="row" pad="small">
                    <Box>
                        <Text size='medium'>
                            Произошла ошибка приложения: {error?.message}
                        </Text>
                    </Box>
                </Box>
            </CardBody>
            <CardFooter pad="small" direction='row'
                background="light-2" justify='end'>
                <Button
                    label='Перезагрузить страницу'
                    color='brand'
                    pad='medium'
                    size='small'
                    onClick={() => window.location.reload()}
                />
            </CardFooter>
        </Card >

    )
}

function RenderingErrorFallback({ error }) {
    return (
        <Card width='25rem' animation='fadeIn' margin='5rem auto'>
            <CardHeader justify='center' background='#ca0a0a'>
                <Text color="#fff" size='medium' margin='small'>Ошибка</Text>
            </CardHeader>
            <CardBody pad="medium">
                <Box gap="small" justify="center" direction="row" pad="small">
                    <Box>
                        <Text size='medium'>
                            Произошла ошибка на странице: {error?.message}
                        </Text>
                    </Box>
                </Box>
            </CardBody>
            <CardFooter pad="small" direction='row'
                background="light-2" justify='end'>
                <Button
                    label='Перезагрузить страницу'
                    color='brand'
                    pad='medium'
                    size='small'
                    onClick={() => window.location.reload()}
                />
            </CardFooter>
        </Card >
    )
}

export {
    FullPageRenderingErrorFallback,
    RenderingErrorFallback
}